export enum HoursTypeEnum {
  WorkingHours = 1,
  PeakHours = 2,
  AfterHours = 3,
  AllDay = 4
}
